<template>
    <div class="app-container">
        <list ref="list">
            <template slot="toolbar-right">
                <el-button class="filter-item" type="primary" @click="create" v-if="$permission.canWrite()" icon="el-icon-plus">添加</el-button>
                <el-button class="filter-item" type="danger" @click="delRows" v-if="$permission.canDel()">删除</el-button>
                <el-button v-if="$permission.canRecord()" type="success" @click="record">备案</el-button>
                <el-button v-if="$permission.canRecord()" type="warning"  @click="unRecord">解除备案</el-button>
                <el-button type="success" plain @click="onImprot()" v-if="$permission.canEdit()">导入</el-button>
                <el-button type="success" plain @click="onExport">导出</el-button>
            </template>
            <el-table-column slot="column" label="操作" fixed="right" align="center" width="115">
                <template slot-scope="{row}">
                    <el-button type="text" size="medium" @click="editById(row.SimulatorId)" v-if="$permission.canEdit()" icon="el-icon-edit" title="编辑"></el-button>
                    <el-button type="text" size="medium" @click="details(row)" icon="el-icon-document" title="查看"></el-button>
                    <el-button v-if="$permission.canDel()&&row.RecordStatus!=3" type="text" size="medium" @click="del(row)" title="删除" icon="el-icon-delete"></el-button>
                    <el-popover placement="bottom" width="50" trigger="hover" v-if="$permission.canEdit()">
                        <p class="c_class" v-if="row.DeviceId == 0" @click="bind(row)">绑定设备</p>
                        <p class="c_class" v-else @click="UnBind(row)">解绑设备</p>
                        <span slot="reference" style="cursor: pointer; margin-left: 10px"><i class="el-icon-more" style="color: #409eff;font-size:14px;"></i></span>
                    </el-popover>
                </template>
            </el-table-column>
        </list>
        <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
        <import-dialog ref="importDialog" @upload-success="reload" />
        <details-dialog ref="detailsDialog" @close-saved="reload"></details-dialog>
        <bind-dialog ref="bindDialog" @close-saved="reload" />
    </div>
</template>
<script>
    import curdMixins from "@/mixins/curd";
    import list from "@/components/operate/simulator/list";
    import editDialog from "@/components/operate/simulator/editDialog";
    import detailsDialog from '@/components/operate/simulator/detailsDialog'
    import importDialog from "@/components/operate/simulator/importDialog";
    import bindDialog from "@/components/operate/simulator/bindDialog";
    export default {
        name: "simulator",
        mixins: [curdMixins],
        components: {
            list,
            editDialog,
            importDialog,
            detailsDialog,
            bindDialog
        },
        data() {
            return {
                api: require("@/api/op/simulator").default,
            }
        },
        methods: {
            del(row) {
                this.$confirm("确认删除吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        if (row.RecordStatus==3) return this.$message.error("备案通过的记录不可以删除");
                        this.$refs.list.delRange([row.SimulatorId]);
                    })
                    .catch(() => { });
            },
            details(row) {
                this.$refs.detailsDialog.openEditById(row.SimulatorId);
            },
            record() {
                let rows = this.$refs.list.getCheckedRows();
                if (rows.length == 0) {
                    this.$message.warning("请选择要备案的数据");
                    return;
                }
                
                this.$confirm("确认备案所选的数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                    let Ids = rows.map((item) => {
                        return item.SimulatorId;
                    });
                    this.api.record({ Ids }).then(res => {
                        if(res.Code==0) {
                        this.reload();
                        this.$message.success(res.Msg);
                        } else {
                        this.$message.error(res.Msg);
                        }
                    })
                })
                .catch(() => {});
            },
            unRecord() {
                let rows = this.$refs.list.getCheckedRows();
                if (rows.length == 0) {
                    this.$message.warning("请选择要解除备案的数据");
                    return;
                }
                var obj = rows.find(x => x.RecordStatus!=3);
                if(obj) return this.$message.error("备案通过的记录才可以解除备案");
                
                this.$confirm("确认解除所选数据的备案吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                    let Ids = rows.map((item) => {
                        return item.SimulatorId;
                    });
                    this.api.unRecord({ Ids }).then(res => {
                        if(res.Code==0) {
                        this.reload();
                        this.$message.success(res.Msg);
                        } else {
                        this.$message.error(res.Msg);
                        }
                    })
                })
                .catch(() => {});
            },
            bind(row) {
                if (row.SimulatorId == 0) {
                    row.SimulatorId = null;
                }
                this.$refs.bindDialog.openEdit(row);
            },
            UnBind(row) {
            this.$confirm("确定要解绑该设备吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                this.api.unBind({ DeviceId: row.DeviceId, SimulatorId: row.SimulatorId }).then((res) => {
                    if (res.Code == 0) {
                        this.reload();
                        this.$message.success(res.Msg);
                    } else {
                        this.$message.error(res.Msg);
                    }
                    });
                })
                .catch(() => {});
            },
            delRows() {
                let rows = this.$refs.list.getCheckedRows();
                if (rows.length == 0) {
                    this.$message.warning("请选择要删除的数据");
                    return;
                }
                this.$confirm("确认删除所选的数据吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var obj = rows.find((x) => x.RecordStatus == 3);
                        if (obj) return this.$message.error("备案通过的记录不可以删除");
                        let ids = rows.map((item) => {
                            return item.SimulatorId;
                        });
                        this.$refs.list.delRange(ids);
                    })
                    .catch(() => { });
            },
            onExport() {
                this.$refs.list.onExport();
            },
            onImprot() {
                this.$refs.importDialog.open();
            },
        },
    };
</script>
<style scoped>
.c_class {
  cursor: pointer;
}
</style>